import { useState } from "react";
import { LuLoaderCircle, LuSave } from "react-icons/lu";
import { useSnackbar } from "../../../providers/SnackbarProvider";
import { useProjectIconActions } from "../../../view_stores/useProjectIconStore";

export default function ProjectIconUploadedImageActions() {
  const { saveUploadedImage, setUploadedImage } = useProjectIconActions();
  const { showSnackbar } = useSnackbar();
  const [isSaving, setIsSaving] = useState(false);

  const handleRemoveImage = () => {
    setUploadedImage(null);
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await saveUploadedImage();
      showSnackbar("Image saved successfully");
    } catch (e) {
      showSnackbar("Failed to save image. Try again later.", {
        type: "error",
      });
    }
    setIsSaving(false);
  };

  return (
    <>
      <button
        id="project-icon-uploaded-image-actions-remove"
        onClick={handleRemoveImage}
        className="text-light-placeholder dark:text-dark-placeholder
                hover:brightness-125 hover:cursor-pointer
                transition-all duration-300 px-4"
        disabled={isSaving}
      >
        Cancel
      </button>
      <button
        id="project-icon-uploaded-image-actions-save"
        className="flex items-center gap-3
        bg-[#16A34A] rounded-md
        text-white
        py-2 px-4
        hover:brightness-125 hover:cursor-pointer
        transition-all duration-300"
        onClick={handleSave}
        disabled={isSaving}
      >
        {isSaving ? (
          <LuLoaderCircle className="animate-spin text-white" size={20} />
        ) : (
          <LuSave size={20} />
        )}
        {isSaving ? "Saving..." : "Save"}
      </button>
    </>
  );
}
